import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteCampaign = async (token: string, campaignId: number) => {
  try {
    const { data } = await Client.delete(`campaign/${campaignId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('DeleteCampaign', {
      DeleteCampaign: data
    });
    return { data };
  } catch (response) {
    const result = { response } as any;
    return { errors: result.data };
  }
};
